module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/btn-apply-5f80a4c326ee23f09f67da45e73524f3.png";